import { OrderType } from 'types';

export const SIGN_BDO_STATEMENT_COMMAND_TYPE = 'SignBdoStatement';

export interface SignBdoStatementCommand {
	orderId: number;
	orderType: OrderType.classic | OrderType.loose;
	signature: string;
}
